export default __webpack_public_path__ + "static/media/lantern.b4621723.mp4";